<template>
    <modal
        title="Beteiligte Person"
        ref="modal"
        :showDismissMessage="showDismissMessage"
    >
        <form @submit.prevent="submitForm">
            <ion-card class="-light">
                <ion-grid>
                    <base-select
                        v-model="beteiligteFormData.rolle"
                        id="rolle"
                        label="Rolle"
                    >
                        <ion-select-option
                            v-if="!isRechtschutz"
                            value="Fahrzeuglenker(in)"
                            >Fahrzeuglenker(in)</ion-select-option
                        >
                        <ion-select-option
                            v-if="!isRechtschutz"
                            value="Geschädigte(r)"
                            >Geschädigte(r)</ion-select-option
                        >
                        <ion-select-option
                            v-if="isRechtschutz"
                            value="Beschuldigte(r)"
                            >Beschuldigte(r)</ion-select-option
                        >

                        <ion-select-option value="Zeuge/Zeugin"
                            >Zeuge/Zeugin</ion-select-option
                        >
                        <ion-select-option value="Sonstige(r)"
                            >Sonstige(r)</ion-select-option
                        >
                    </base-select>

                    <ion-item
                        lines="none"
                        v-if="beteiligteFormData.rolle == 'Fahrzeuglenker(in)'"
                    >
                        <base-checkbox
                            id="versicherungsnehmer"
                            v-model="beteiligteFormData.versicherungsnehmer"
                        ></base-checkbox>
                        <ion-label text-wrap
                            >Fahrzeuglenker(in) ist
                            Versicherungsnehmer(in)</ion-label
                        >
                    </ion-item>
                </ion-grid>
            </ion-card>

            <personal-data
                v-if="
                    !beteiligteFormData.versicherungsnehmer ||
                    beteiligteFormData.rolle != 'Fahrzeuglenker(in)'
                "
                :geschlecht.sync="beteiligteFormData.geschlecht"
                :titel.sync="beteiligteFormData.titel"
                :vorname.sync="beteiligteFormData.vorname"
                :zuname.sync="beteiligteFormData.zuname"
                :strasse.sync="beteiligteFormData.strasse"
                :hausnr.sync="beteiligteFormData.hausnr"
                :stiege.sync="beteiligteFormData.stiege"
                :stock.sync="beteiligteFormData.stock"
                :tuer.sync="beteiligteFormData.tuer"
                :plz.sync="beteiligteFormData.plz"
                :ort.sync="beteiligteFormData.ort"
                :email.sync="beteiligteFormData.email"
                :telefon.sync="beteiligteFormData.telefon"
                :geburtsdatum.sync="beteiligteFormData.geburtsdatum"
                :hasInputErrorFields="false"
            ></personal-data>
            <ion-card class="-light" v-if="isRechtschutz">
                <ion-item lines="none">
                    <base-checkbox
                        id="beschuldigtezeugenInsasse"
                        v-model="beteiligteFormData.beschuldigtezeugenInsasse"
                    ></base-checkbox>
                    <ion-label text-wrap>Insasse im eigenen Fahrzeug</ion-label>
                </ion-item>
            </ion-card>

            <ion-card
                class="-light"
                v-if="beteiligteFormData.rolle == 'Fahrzeuglenker(in)'"
            >
                <h2>Führerschein</h2>

                <base-input
                    class="ion-margin-bottom"
                    type="number"
                    v-model="beteiligteFormData.fuehrerscheinNummer"
                    label="Führerscheinnummer"
                    id="fuehrerscheinNummer"
                ></base-input>

                <base-input
                    class="ion-margin-bottom"
                    type="text"
                    v-model="beteiligteFormData.fuehrerscheinFahrzeuggruppe"
                    label="Fahrzeuggruppe"
                    id="fuehrerscheinFahrzeuggruppe"
                ></base-input>

                <base-input
                    class="ion-margin-bottom"
                    type="text"
                    v-model="beteiligteFormData.fuehrerscheinBehoerde"
                    label="Behörde"
                    id="fuehrerscheinBehoerde"
                ></base-input>

                <base-datetime
                    class="ion-margin-bottom"
                    label="Ausstellungsdatum"
                    v-model="beteiligteFormData.fuehrerscheinAusstellungsdatum"
                    id="fuehrerscheinAusstellungsdatum"
                ></base-datetime>
            </ion-card>
        </form>
        <template v-slot:footer>
            <ion-button
                expand="block"
                class="ion-margin-top"
                @click="submitForm()"
                >{{
                    beteiligteData === undefined ? "Hinzufügen" : "Speichern"
                }}</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import BaseInput from "./BaseInput";
import BaseSelect from "./BaseSelect";
import BaseCheckbox from "./BaseCheckbox";
import BaseDatetime from "./BaseDatetime";
import PersonalData from "@/components/PersonalData";

export default {
    props: {
        beteiligteId: {
            type: Number,
            required: false,
        },
        beteiligteData: {
            type: Object,
            required: false,
        },
        isRechtschutz: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    components: {
        Modal,
        PersonalData,
        BaseCheckbox,
        BaseDatetime,
        BaseInput,
        BaseSelect,
        // BaseTextarea
    },
    data() {
        return {
            beteiligteFormData: {
                beteiligteId: "",
                rolle: "",
                versicherungsnehmer: false,
                fuehrerscheinAusstellungsdatum: "",
                fuehrerscheinNummer: "",
                fuehrerscheinFahrzeuggruppe: "",
                fuehrerscheinBehoerde: "",
                geschlecht: "",
                titel: "",
                vorname: "",
                zuname: "",
                strasse: "",
                hausnr: "",
                stiege: "",
                stock: "",
                tuer: "",
                plz: "",
                ort: "",
                email: "",
                telefon: "",
                geburtsdatum: "",
                beschuldigtezeugenInsasse: false,
            },
            changeBeteiligteFormDataCount: 0,
            showDismissMessage: false,
        };
    },
    watch: {
        beteiligteFormData: {
            deep: true,

            handler(value) {
                if (this.changeBeteiligteFormDataCount > 0) {
                    this.showDismissMessage = true;
                }

                if (value.rolle != "Fahrzeuglenker(in)") {
                    this.beteiligteFormData.versicherungsnehmer = false;
                }
                this.changeBeteiligteFormDataCount++;
            },
        },
    },
    mounted() {
        this.$set(this.beteiligteFormData, "beteiligteId", this.beteiligteId);
        if (this.beteiligteData) {
            this.beteiligteFormData = this.beteiligteData;
        }
    },

    methods: {
        submitForm() {
            this.$ionic.modalController.dismiss({
                beteiligteFormData: Object.assign({}, this.beteiligteFormData),
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
